import Vue from 'vue'
import VueRouter from 'vue-router'
//import store from "../store/modules/common";
import Home from '../pages/Dashboard/Home.vue'
//import Public from '../pages/App/Public'
import Login from '../pages/App/Login'
import Logout from '../pages/App/Logout'
import AdminRoutes from './administrasi'
//import DataRoutes from './data'
import AssetRoutes from './asset'

Vue.use(VueRouter)

const routes = [
  ...AdminRoutes,
  //...DataRoutes,
  ...AssetRoutes,
  {
    path: '/',
    component: Login,
    meta: { title: 'OPTIMASI ASET', noauth: true },
  },
  {
    path: '/Main/App/Home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: 'OPTIMASI ASET', noauth: true },
  },
  {
    path: '/Main/App/Logout',
    name: 'Logout',
    component: Logout,
    meta: { noauth: true },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.noauth) return next()
  else {
    if (localStorage.getItem('menu-access')) {
      // next()
      let menu = JSON.parse(localStorage.getItem('menu-access'))
      if (to.path === '/') next()
      else {
        // let pages = store.state.user.pages
        // if (pages[to.path] && pages[to.path].access) {
        //   store.state.pageId = pages[to.path].id
        //   return next()
        // } else {
        //   return next({ path: '/notfound' })
        // }
        if (menu[to.path]) {
          sessionStorage.setItem('coms-access', JSON.stringify(menu[to.path]))
          window._AccessMode = menu[to.path]
          return next()
        } else {
          let found = false
          for (let m in menu) {
            if (to.path.match(m)) {
              found = true
              window._AccessMode = menu[m]
              break
            }
          }
          if (found) {
            return next()
          } else {
            return next({ path: '/Main/App/Home' })
          }
        }
      }
    } else {
      return next({ path: '/login' })
    }
  }
})
const DEFAULT_TITLE = 'SIPMASSE'
router.afterEach(to => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE
  })
})

export default router
